import { Layer, type Scope } from "effect";
import { EditorPlatformLive } from "./platform-live.ts";
import { EditorModelIoLazyLive } from "./model-io-live.ts";
import { EditorLanguageIoLive } from "./language-live.ts";
import { EditorProjectTypesLive } from "./project-types-live.ts";
import { EditorProjectsLive } from "./project-operations.ts";
import { EditorWidgetIoLive } from "./widget-live.ts";
import { EditorViewsLive } from "./view-operations.ts";
export const EditorsRootLive = (owner: Scope.Scope) => EditorViewsLive(owner).pipe(Layer.provideMerge(EditorProjectsLive(owner)), Layer.provide(Layer.mergeAll(EditorModelIoLazyLive, EditorLanguageIoLive, EditorProjectTypesLive, EditorWidgetIoLive).pipe(Layer.provide(EditorPlatformLive))));
